import { ArrowBack } from "@mui/icons-material"
import { IconButton, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { isRtlLang } from "src/i18n/config"
import { Conditional, Stack } from "src/shared/components"

const TitleWithBackButton = ({ href, title }: { href: string; title?: string }) => {
  const navigate = useNavigate()
  const { i18n } = useTranslation()
  const isRtl = isRtlLang(i18n.resolvedLanguage ?? i18n.language)

  return (
    <Stack direction={"row"} justifyContent={"flex-start"} spacing={1} mb={3}>
      <IconButton onClick={() => navigate(href)}>
        <ArrowBack sx={{ transform: isRtl ? "scaleX(-1)" : "none" }} />
      </IconButton>
      <Conditional condition={!!title}>
        <Typography variant="h2">{title}</Typography>
      </Conditional>
    </Stack>
  )
}

export default TitleWithBackButton
